// extracted by mini-css-extract-plugin
export default {"report-actions":"project-report-page_report-actions__KjpwX","report-actions-spacer":"project-report-page_report-actions-spacer__vnc0b"};